import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var importTranslations = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.t0 = locale;
          _context.next = _context.t0 === 'cs-CZ' ? 3 : _context.t0 === 'da-DK' ? 4 : _context.t0 === 'de-DE' ? 5 : _context.t0 === 'en-US' ? 6 : _context.t0 === 'en-GB' ? 7 : _context.t0 === 'en-ZZ' ? 8 : _context.t0 === 'es-ES' ? 9 : _context.t0 === 'fi-FI' ? 10 : _context.t0 === 'fr-FR' ? 11 : _context.t0 === 'hu-HU' ? 12 : _context.t0 === 'it-IT' ? 13 : _context.t0 === 'ja-JP' ? 14 : _context.t0 === 'ko-KR' ? 15 : _context.t0 === 'no-NO' ? 16 : _context.t0 === 'nl-NL' ? 17 : _context.t0 === 'pl-PL' ? 18 : _context.t0 === 'pt-BR' ? 19 : _context.t0 === 'ru-RU' ? 20 : _context.t0 === 'sv-SE' ? 21 : _context.t0 === 'tr-TR' ? 22 : _context.t0 === 'th-TH' ? 23 : _context.t0 === 'uk-UA' ? 24 : _context.t0 === 'vi-VN' ? 25 : _context.t0 === 'zh-TW' ? 26 : _context.t0 === 'zh-CN' ? 27 : 28;
          break;
        case 3:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-cs" */'./cs'));
        case 4:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-da" */'./da'));
        case 5:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-de" */'./de'));
        case 6:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-en" */'./en'));
        case 7:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-en_GB" */'./en_GB'));
        case 8:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-en_ZZ" */'./en_ZZ'));
        case 9:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-es" */'./es'));
        case 10:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-fi" */'./fi'));
        case 11:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-fr" */'./fr'));
        case 12:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-hu" */'./hu'));
        case 13:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-it" */'./it'));
        case 14:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-ja" */'./ja'));
        case 15:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-ko" */'./ko'));
        case 16:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-nb" */'./nb'));
        case 17:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-nl" */'./nl'));
        case 18:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-pl" */'./pl'));
        case 19:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-pt_BR" */'./pt_BR'));
        case 20:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-ru" */'./ru'));
        case 21:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-sv" */'./sv'));
        case 22:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-tr" */'./tr'));
        case 23:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-th" */'./th'));
        case 24:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-uk" */'./uk'));
        case 25:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-vi" */'./vi'));
        case 26:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-zh_TW" */'./zh_TW'));
        case 27:
          return _context.abrupt("return", import( /* webpackChunkName: "@atlaskit-internal_embedded-confluence-i18n-zh" */'./zh'));
        case 28:
          return _context.abrupt("return", Promise.resolve({
            default: {}
          }));
        case 29:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function importTranslations(_x) {
    return _ref.apply(this, arguments);
  };
}();
var fetchTranslations = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(locale) {
    var module;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return importTranslations(locale);
        case 2:
          module = _context2.sent;
          return _context2.abrupt("return", module.default);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function fetchTranslations(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export default fetchTranslations;